import { render, staticRenderFns } from "./wechatVideo.vue?vue&type=template&id=0cf7a89a&scoped=true&"
import script from "./wechatVideo.vue?vue&type=script&lang=ts&"
export * from "./wechatVideo.vue?vue&type=script&lang=ts&"
import style0 from "./wechatVideo.vue?vue&type=style&index=0&id=0cf7a89a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf7a89a",
  null
  
)

export default component.exports